import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase, PickupResult, PickupResultCode } from 't4core';
import { ActivatedRoute, } from '@angular/router';
import { NavigationService } from 'app-components';
import { ActiveRentalService } from 'app-components';
import { LayoutService } from 'app-components';

@Component({
    selector: 'app-start-rental',
    templateUrl: './start-rental.html',
    standalone: false
})
export class StartRentalComponent extends PageBase implements OnInit {
  public loading: boolean = true;
  public errorCode: string = "";


  constructor(private navigationService: NavigationService, private rentalService: ActiveRentalService, el: ElementRef, private route: ActivatedRoute,  private layoutService: LayoutService) {
    super(el);

    // Validate state
    //if (!this.rentalService.booking || this.rentalService.booking.Id == 0) {
      // Display error and abort
    //}
  }

  async ngOnInit() {
    var discloseResult = await this.rentalService.startRental();

    // Successful?
    if (discloseResult == PickupResultCode.SuccessWithoutPayment || discloseResult == PickupResultCode.SuccessWithPayment || discloseResult == PickupResultCode.InvoicePayment) {
      this.navigationService.executeCommand("Started");
    }

    // Payment failed
    else if (discloseResult == PickupResultCode.PaymentActionRequired || discloseResult == PickupResultCode.PaymentFailed) {
      let booking = await this.rentalService.getBooking();
      this.navigationService.executeCommand("PaymentFailed", { rentalId: booking.Id });
    }

    // Something else is wrong. Display error and abort
    else {
      let booking = await this.rentalService.getBooking();

      if ((discloseResult == PickupResultCode.InvalidRental || discloseResult == PickupResultCode.WrongStatus) && booking.Status == 100) {
        this.navigationService.executeCommand("Started");
      }
      else {
        const name = PickupResultCode[discloseResult];
        this.errorCode = `${name} (${discloseResult})`;

      }
      this.loading = false;
    }
    
  }

  public goTo(command: string) {
    this.navigationService.executeCommand(command);
  }


}
